/**
 * Practice while an övningstenta is running (P2-12, same pattern as the library guard, slice D fix
 * I1): the whole `/practice` tree says so and leads back to the session. `examActive` is
 * server-backed, so a new tab or a typed URL gets the same restriction as the shell's hidden nav.
 */
import { Link, Outlet } from "react-router";
import { ExamCheckFailed } from "@client/app/ExamCheckFailed";
import { useExamMode } from "@client/app/examMode";
import { EmptyState, Spinner } from "@client/components/ui";
import { useT } from "@client/i18n";

export function PracticeExamGuard() {
  const t = useT();
  const { examActive, examChecking, examError } = useExamMode();
  // A fresh tab must not flash the practice page before the server has answered.
  if (examChecking) return <Spinner size="md" label={t("common.loading")} />;
  // Fail closed: an unanswered check keeps the page locked and offers a retry.
  if (examError) return <ExamCheckFailed />;
  if (!examActive) return <Outlet />;
  return (
    <div className="mx-auto max-w-2xl">
      <EmptyState
        title={t("practice.examLocked.title")}
        body={t("practice.examLocked.body")}
        action={
          <p className="flex flex-wrap justify-center gap-4 text-sm font-medium">
            <Link to="/exam/session" className="underline underline-offset-2">
              {t("practice.examLocked.back")}
            </Link>
          </p>
        }
      />
    </div>
  );
}
